import { render, staticRenderFns } from "./Penjamin.vue?vue&type=template&id=4b5f7124&"
import script from "./Penjamin.vue?vue&type=script&lang=js&"
export * from "./Penjamin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports